export default "__VITE_ASSET__Bf3OL4RD__"